import React, { useState, useEffect } from 'react';
import StepFormTemplate from "../../templates/step-form.template";
import { NumberVerificationTemplate } from '../../templates/number-verification.template';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { checkUserService, createUserService } from '../../../services/new-services/auth-v2.services';
import { updateAuthToken } from '../../../redux/slices/application-process.slice';
import { requestPhoneOTPService, validatePhoneOTPService } from '../../../services/new-services/otp-v2.services';
import { toast } from 'react-toastify';
const NumberVerificationScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const authToken = useSelector(state => state.applicationProcess.authToken);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [otpCode, setOtpCode] = useState('');
  const [isPhoneInUse, setIsPhoneInUse] = useState(false);
  const [phoneVerified, setPhoneVerified] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [resetToken, setResetToken] = useState(null);
  const [currentStep, setCurrentStep] = useState(0);

  const handlePhoneNumberInput = (number) => {
    setPhoneNumber(number);
    setIsPhoneInUse(false);
  };

  async function handlePhoneVerification(messageType = 'whatsapp') {
    setIsLoading(true);
    let currentAuthToken = authToken;
    if (!currentAuthToken) {
      const response = await checkUserService(phoneNumber);
      if (response.success && response.data.hasAccount) {
        setIsPhoneInUse(true);
        setIsLoading(false);
        return;
      }
      let creationResponse = await createUserService(phoneNumber);
      if (!creationResponse.success) {
        setIsLoading(false);
        return;
      }
      currentAuthToken = creationResponse.data.accessToken;
      dispatch(updateAuthToken(currentAuthToken));
    }
    let requestResponse = await requestPhoneOTPService(currentAuthToken, phoneNumber, messageType);
    if (!requestResponse.success) {
      setIsLoading(false);
      return;
    }
    setResetToken(requestResponse.data.accessToken);
    setCurrentStep(1);
    setIsLoading(false);
    return true;
  }

  const handleOtpCodeInput = (code) => {
    setOtpCode(code);
    if (code.length === 5) {
      verifyCode(code);
    }
  };

  function getCurrentDescription() {
    if (currentStep === 0) {
      return 'Te enviaremos un código de verificación. Asegúrate de que el número esté correcto';
    } else if (currentStep === 1) {
      const formatted = phoneNumber.replace(
        /(\d{2})(\d{4})(\d{0,4})/,
        (match, p1, p2, p3) => `+52 ${p1} ${p2} ${p3}`.trim()
      );
      return `Ingresa el código enviado al ${formatted}`;
    } else if (currentStep === 2) {
      return 'Número verificado exitosamente';
    }
  }

  const verifyCode = async (code) => {
    setIsLoading(true);
    const response = await validatePhoneOTPService(authToken, code, resetToken);
    if (!response.success) {
      toast.error("Error al verificar código", { autoClose: 1500 });
      setIsLoading(false);
      return;
    }
    dispatch(updateAuthToken(response.data.accessToken));
    setIsLoading(false);
    setPhoneVerified(true);
    setCurrentStep(2);
  };

  const handleNext = () => {
    navigate('/app/application/evaluation');
  };

  return (
    <div style={styles.mainContainerStyle}>
      <StepFormTemplate
        title="Verifica tu número de celular"
        currentStep={5}
        totalSteps={5}
        submitEnabled={phoneVerified}
        buttonTitle="Finalizar Solicitud"
        onSubmit={handleNext}
        description={getCurrentDescription()}
        onClose={() => navigate('/')}
      >
        <NumberVerificationTemplate
          currentStep={currentStep}
          setCurrentStep={setCurrentStep}
          isLoading={isLoading}
          phoneNumber={phoneNumber}
          onPhoneNumberInput={handlePhoneNumberInput}
          otpCode={otpCode}
          onOtpCodeInput={handleOtpCodeInput}
          isPhoneInUse={isPhoneInUse}
          onRequestVerificationCode={() => handlePhoneVerification('whatsapp')}
          onRequestVerificationCodeSMS={() => handlePhoneVerification('sms')}
        />
      </StepFormTemplate>
    </div>
  );
};


const styles = {
  mainContainerStyle: {
      margin: '0 auto',
      padding: window.innerWidth > 700 ? '0 25%' : '0'
  }
}


export default NumberVerificationScreen; 